<template>
    <div class="widgets-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="row">
                    <div class="col-lg-3 col-sm-6">
                        <div class="card single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-world' ></i>
                                <span class="d-block">Total Visited</span>
                                <h4 class="card-title">10.5k</h4>
                                <p class="card-text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Officiis, rem asperiores saepe error molestias, aut ex earum, laborum</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="card single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-dollar-circle'></i>
                                <span class="d-block">Total Earned</span>
                                <h4 class="card-title">$350k</h4>
                                <p class="card-text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Officiis, rem asperiores saepe error molestias, aut ex earum, laborum</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="card single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-message-alt-dots' ></i>
                                <span class="d-block">Investment</span>
                                <h4 class="card-title">15.5k</h4>
                                <p class="card-text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Officiis, rem asperiores saepe error molestias, aut ex earum, laborum</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="card single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-bar-chart-square' ></i>
                                <span class="d-block">Total Visited</span>
                                <h4 class="card-title">10.5k</h4>
                                <p class="card-text">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Officiis, rem asperiores saepe error molestias, aut ex earum, laborum</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets-two border-0"> 
                            <div class="card-body p-0"> 
                                <div class="d-flex align-items-center"> 
                                    <div class="text-white"> 
                                        <h4 class="mb-0">25,457</h4> 
                                        <p class="text-white mb-0">Total Requests</p>
                                    </div> 
                                    <div class="ms-auto"> 
                                        <i class='bx bx-user text-white'></i>
                                    </div> 
                                </div> 
                            </div> 
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets-two border-0 bg-5c31d6"> 
                            <div class="card-body p-0"> 
                                <div class="d-flex align-items-center"> 
                                    <div class="text-white"> 
                                        <h4 class="mb-0">37,536</h4> 
                                        <p class="text-white mb-0">Total Traffic</p>
                                    </div> 
                                    <div class="ms-auto"> 
                                        <i class='bx bx-bar-chart-square text-white' ></i>
                                    </div> 
                                </div> 
                            </div> 
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets-two border-0 bg-fe5957"> 
                            <div class="card-body p-0"> 
                                <div class="d-flex align-items-center"> 
                                    <div class="text-white"> 
                                        <h4 class="mb-0">23,536</h4> 
                                        <p class="text-white mb-0">Total Profit</p>
                                    </div> 
                                    <div class="ms-auto"> 
                                        <i class='bx bx-dollar-circle text-white'></i>
                                    </div> 
                                </div> 
                            </div> 
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets-two border-0 bg-fec107"> 
                            <div class="card-body p-0"> 
                                <div class="d-flex align-items-center"> 
                                    <div class="text-white"> 
                                        <h4 class="mb-0">23,536</h4> 
                                        <p class="text-white mb-0">Monthly Sales</p>
                                    </div> 
                                    <div class="ms-auto"> 
                                        <i class='bx bx-cart text-white'></i>
                                    </div> 
                                </div> 
                            </div> 
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-world text-primary'></i>
                                <span class="d-block">Total Visited</span>
                                <h4 class="card-title">10.5k</h4>
                                <div class="progress mt-3">
                                    <div class="progress-bar" role="progressbar" aria-label="Example with label" style="width: 50%;" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">50%</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-dollar-circle text-success'></i>
                                <span class="d-block">Total Earned</span>
                                <h4 class="card-title">$350k</h4>
                                <div class="progress mt-3">
                                    <div class="progress-bar bg-success" role="progressbar" aria-label="Example with label" style="width: 60%;" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">60%</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-message-alt-dots text-warning'></i>
                                <span class="d-block">Investment</span>
                                <h4 class="card-title">15.5k</h4>
                                <div class="progress mt-3">
                                    <div class="progress-bar bg-warning" role="progressbar" aria-label="Example with label" style="width: 70%;" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100">70%</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="single-widgets text-center border-0">
                            <div class="card-body p-0">
                                <i class='bx bx-bar-chart-square text-danger'></i>
                                <span class="d-block">Total Visited</span>
                                <h4 class="card-title">10.5k</h4>
                                <div class="progress mt-3">
                                    <div class="progress-bar bg-danger" role="progressbar" aria-label="Example with label" style="width: 80%;" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">80%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WidgetsContent'
}
</script>

<style lang="scss">
.single-widgets {
	padding: 30px;
	box-shadow: var(--box-shadow);
	margin-bottom: 24px;
	i {
		font-size: 50px;
		color: var(--main-color);
		margin-bottom: 10px;
	}
	span {
		margin-bottom: 10px;
	}
	h4 {
		font-size: 30px;
		font-weight: 500;
	}
}
.single-widgets-two {
	padding: 30px;
	box-shadow: var(--box-shadow);
	background-color: var(--main-color);
	margin-bottom: 24px;
	&.bg-5c31d6 {
		background-color: #5c31d6;
	}
	&.bg-fe5957 {
		background-color: #fe5957;
	}
	&.bg-fec107 {
		background-color: #fec107;
	}
	i {
		font-size: 50px;
		color: var(--main-color);
	}
	h4 {
		font-size: 30px;
		font-weight: 500;
		color: var(--white-color);
	}
}
</style>